import {
  Button,
  Card,
  Collapse,
  ControlGroup,
  Elevation,
  InputGroup,
  Spinner,
  Tag,
  TextArea,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost } from "../fns/util";
import { inject, observer } from "mobx-react";
import _ from "lodash";
import { withRouter } from "react-router";
import cogoToast from "cogo-toast";
import AsyncSelWrap from "../utils/AsyncSelWrap";
import PlanMedicines from "../opto/elems/PlanMedicines";
import PlanAdvice from "../opto/elems/PlanAdvice";
import Analysis from "../opto/elems/Analysis";
import SyntaxTable from "../opto/elems/SyntaxTable";
import TemplateDrawer from "../opto/templates/TemplateDrawer";

import TurboMode from "../opto/turbo/TurboMode";
import SurgicalNotes from "../opto/elems/SurgicalNotes";
import DischargeTemplate from "../opto/elems/DischargeTemplate";

class Discharge extends React.Component {
  state = {
    collapsed: false,
    showTable: false,
    contactSearching: false,
    contactSearchResults: [],
    contactSelected: null,
    files: [],
    surgicalNotes:
      this.props.data.dischargeEntities.filter(
        (each) =>
          each.subsectionName === "SURGERY" && each.sectionName === "NOTES"
      )[0]?.surgicalNotes || "",
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }

  search = async (
    string,
    searchResArray,
    isSearchingShowSpinner,
    selectedItem,
    apiUrl
  ) => {
    if (!string) {
      this.setState({
        [searchResArray]: [],
        [selectedItem]: null,
      });
      return;
    }
    try {
      this.setState({ [isSearchingShowSpinner]: true });
      let payload = { prefix: string || "" };
      let res = await apiCallPost(apiUrl, payload);
      this.setState({
        [searchResArray]: res,
        [isSearchingShowSpinner]: false,
      });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details."
      );
      console.log(err);
    }
  };
  renderAsyncSearchers = (
    tagText,
    placeHolderText,
    stateSearchingKey,
    stateSearchResultsKey,
    stateSelectedItemKey,
    searchApiUrl
  ) => {
    return (
      <ControlGroup>
        <Tag large minimal>
          {tagText}
        </Tag>
        <AsyncSelWrap
          disabled={this.props.isBusy || this.state.isWaitingOnLineItem}
          placeholder={placeHolderText}
          searching={this.state[stateSearchingKey]}
          items={this.state[stateSearchResultsKey].map((each) => {
            return {
              ...each,
              item: each.entityName,
              entityTypeString: each.phone,
              helper: each.availability,
            };
          })}
          selectedItem={null}
          update={(string) =>
            this.search(
              string,
              stateSearchResultsKey,
              stateSearchingKey,
              stateSelectedItemKey,
              searchApiUrl
            )
          }
          onChange={(chosenItem) => {
            if (placeHolderText === "Contacts") {
              this.props.onUpdate({
                postSxContact: `Please contact ${chosenItem.entityName} at ${chosenItem.phone} (${chosenItem.availability}) for any queries.`,
              });
            } else {
              this.setState({ [stateSelectedItemKey]: chosenItem });
            }
          }}
        />
        {this.state.isWaitingOnLineItem ? <Spinner size={20} /> : null}
      </ControlGroup>
    );
  };

  onBulkAdd = async (obj, eye) => {
    cogoToast.info("Starting addition from template...");

    let updates = [];

    for (let i = 0; i < obj.length; i++) {
      const currentItem = obj[i];
      updates.push({ ...currentItem, laterality: eye });
    }

    this.props.onUpdate({
      dischargeEntities: [...this.props.data.dischargeEntities, ...updates],
    });

    this.setState({ showTemplateDrawer: false });
  };

  removeVisitEntity = async (_id, laterality = null) => {
    if (laterality) {
      let item = _.find(this.state.visitEntities, (each) => each._id === _id);
      if (item.laterality === "BILATERAL") {
        if (laterality === "RIGHT") {
          item.laterality = "LEFT";
          this.updateVisitEntity(item);
          return;
        } else if (laterality === "LEFT") {
          item.laterality = "RIGHT";
          this.updateVisitEntity(item);
          return;
        } else {
        }
      }
    }
    let prefix, payload;
    if (this.state.mode === "CLINICAL") {
      prefix = "clinical2";
      payload = {
        cvEntityId: _id,
      };
    } else {
      prefix = "clinical-template2";
      payload = {
        entityId: _id,
        templateId: this.state.templateId,
      };
    }
    try {
      await apiCallPost(
        `/${prefix}/${this.props.authStore.prefix}/cventity/delete`,
        payload
      );
      let idx = _.findIndex(
        this.state.visitEntities,
        (each) => each._id === _id
      );
      let newVisitEntities = this.state.visitEntities;
      newVisitEntities.splice(idx, 1);
      this.setState({ visitEntities: newVisitEntities });
    } catch (err) {
      cogoToast.error("Error removing entity.");
      console.log(err);
    }
  };
  updateVisitEntity = async (item) => {
    let i = await this.tryToFindSearchMatch(item);

    i.numSearchesBeforeAdding = item.numSearchesBeforeAdding
      ? item.numSearchesBeforeAdding
      : 0;
    let prefix, payload;
    if (this.state.mode === "CLINICAL") {
      prefix = "clinical2";
      payload = {
        cvEntityId: i._id,
        payload: i,
      };
      if (
        payload.payload.organ == "EYE" &&
        payload.payload.anatomicalPart == null
      ) {
        payload.payload.anatomicalPart = "EYE_GENERAL";
      } else if (payload.payload.organ === "SYSTEMIC") {
        payload.payload.anatomicalPart = "";
      }
    } else {
      prefix = "clinical-template2";
      payload = {
        payload: i,
        entityId: i._id,
        templateId: this.state.templateId,
      };
      if (
        payload.payload.organ == "EYE" &&
        payload.payload.anatomicalPart == null
      ) {
        payload.payload.anatomicalPart = "EYE_GENERAL";
      } else if (payload.payload.organ === "SYSTEMIC") {
        payload.payload.anatomicalPart = "";
      }
    }

    try {
      let res = await apiCallPost(
        `/${prefix}/${this.props.authStore.prefix}/cventity/update`,
        payload
      );
      let idx = _.findIndex(
        this.state.visitEntities,
        (each) => each._id === i._id
      );
      let newVisitEntities = this.state.visitEntities;
      newVisitEntities[idx] = { ...res, isShortForm: false }; // Do not auto-collapse on update
      this.setState({
        visitEntities: newVisitEntities,
        recentItems: [
          ...this.state.recentItems,
          {
            _id: i._id,
            type: "UPDATE",
            ts: new Date(),
          },
        ],
      });
    } catch (err) {
      cogoToast.error("Error updating entity.");
      this.setState({
        visitEntities: [...this.state.visitEntities],
      });
      console.log(err);
    }
  };

  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          <Card elevation={Elevation.FOUR}>
            <Tag large intent="primary" style={{ marginBottom: "10px" }}>
              Discharge
            </Tag>
            <Button
              icon="double-chevron-down"
              outlined
              onClick={() => this.setState({ collapsed: false })}
            />
          </Card>
        </Collapse>
        <Collapse isOpen={!this.state.collapsed}>
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large fill intent="primary">
                Discharge
              </Tag>
              <Button
                outlined
                icon="code-block"
                text="Templates"
                onClick={() => this.setState({ showTemplateDrawer: true })}
              />
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => {
                  this.setState({ collapsed: true });
                }}
              />
            </ControlGroup>
            <div
              style={
                this.props.canEdit
                  ? {}
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                    }
              }
            >
              <SyntaxTable
                showTable={this.state.showTable}
                onClose={() => this.setState({ showTable: false })}
              />
              <TemplateDrawer
                onBulkAdd={(obj, eye) => this.onBulkAdd(obj, eye)}
                showTemplateDrawer={this.state.showTemplateDrawer}
                onClose={() => this.setState({ showTemplateDrawer: false })}
              />
              <TurboMode
                data={this.state}
                addVisitEntity={(data, eye) => {
                  console.log("data here", data, eye);
                  // this.onBulkAdd([data], eye);
                  let list = data;
                  if (_.isArray(data) == false) {
                    list = [data];
                  }

                  const sNotes = list.filter(
                    (each) => each.entityType === "SURGICAL_NOTES"
                  );
                  const others = list.filter(
                    (each) => each.entityType !== "SURGICAL_NOTES"
                  );
                  this.setState({
                    surgicalNotes: `${this.state.surgicalNotes} ${sNotes
                      .map((each) => each.entityName)
                      .join(" ")}`,
                  });
                  this.onBulkAdd(others, eye);
                }}
                onFile={(file) =>
                  this.setState({ files: [...this.state.files, file] })
                }
                key={"DISCHARGE_TURBO"}
              />
              <ControlGroup>
                <Tag large intent="primary" interactive>
                  Surgical Notes
                </Tag>

                <TextArea
                  style={{ lineHeight: "1.5" }}
                  fill
                  value={this.state.surgicalNotes}
                  onChange={(event) => {
                    this.setState({ surgicalNotes: event.target.value });
                  }}
                  onBlur={() => {
                    const dischargeEntitiesUpdated = _.clone(
                      this.props.data.dischargeEntities
                    );
                    let discharge = dischargeEntitiesUpdated.filter(
                      (each) =>
                        each.subsectionName === "SURGERY" &&
                        each.sectionName === "NOTES"
                    );

                    if (discharge.length === 0) {
                      dischargeEntitiesUpdated.push({
                        subsectionName: "SURGERY",
                        sectionName: "NOTES",
                        surgicalNotes: this.state.surgicalNotes,
                      });
                    } else {
                      discharge[0].surgicalNotes = this.state.surgicalNotes;
                      dischargeEntitiesUpdated[
                        dischargeEntitiesUpdated.findIndex(
                          (each) =>
                            each.subsectionName === "SURGERY" &&
                            each.sectionName === "NOTES"
                        )
                      ] = discharge[0];
                    }

                    this.props.onUpdate({
                      dischargeEntities: dischargeEntitiesUpdated,
                      changed: true,
                    });
                  }}
                />
              </ControlGroup>

              <br />

              {/* <SurgicalNotes
                data={this.props.data}
                onUpdate={(data) => this.props.onUpdate(data)}
              /> */}

              <Analysis
                // setShowDischarge={(val) => this.props.setShowDischarge(val)}
                data={this.props.data}
                onUpdate={(data) => this.props.onUpdate(data)}
                removeVisitEntity={(id, laterality) =>
                  this.removeVisitEntity(id, laterality)
                }
                updateVisitEntity={(item) => this.updateVisitEntity(item)}
              />
              <PlanMedicines
                onShowTable={() => this.setState({ showTable: true })}
                data={this.props.data}
                onUpdate={(data) => this.props.onUpdate(data)}
              />

              <br />
              <PlanAdvice
                data={this.props.data}
                onUpdate={(data) => this.props.onUpdate(data)}
              />
              <br />
              <DischargeTemplate
                data={this.props.data}
                onUpdate={(data) => this.props.onUpdate(data)}
              />
              <br />

              <ControlGroup>
                <Tag minimal intent="primary" large>
                  Follow Up Details
                </Tag>
                <InputGroup
                  fill
                  value={this.props.data.followUpAppt}
                  onChange={(event) => {
                    this.props.onUpdate({
                      followUpAppt: event.target.value,
                    });
                  }}
                />
              </ControlGroup>
              <br />
              <ControlGroup>
                <Tag minimal intent="primary" large>
                  Discharge Notes
                </Tag>
                <Button
                  icon="clean"
                  outlined
                  onClick={() => {
                    this.props.onUpdate({
                      dischargeNotes:
                        "Patient exhibits systemic stability and ocular condition remains stable upon discharge.",
                    });
                  }}
                />
                <InputGroup
                  fill
                  value={this.props.data.dischargeNotes}
                  onChange={(event) => {
                    this.props.onUpdate({
                      dischargeNotes: event.target.value,
                    });
                  }}
                />
              </ControlGroup>
              <ControlGroup>
                {this.props.data.postSxContact ? (
                  <>
                    <Tag
                      intent="primary"
                      minimal
                      large
                      onRemove={() => {
                        this.props.onUpdate({
                          postSxContact: null,
                        });
                      }}
                    >
                      Post Sx Contact
                    </Tag>
                    <InputGroup
                      fill
                      value={this.props.data.postSxContact}
                      onChange={(event) => {
                        this.props.onUpdate({
                          postSxContact: event.target.value,
                        });
                      }}
                    />
                  </>
                ) : (
                  <>
                    {this.renderAsyncSearchers(
                      "Post Sx Contact",
                      "Contacts",
                      "contactSearching",
                      "contactSearchResults",
                      "contactSelected",
                      `/meta-sx/${this.props.authStore.prefix}/SxPostSurgeryContactList/search`
                    )}
                  </>
                )}
              </ControlGroup>
            </div>
          </Card>
        </Collapse>
      </>
    );
  };
  render() {
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(Discharge)));
